import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as Calendar } from 'assets/svg/icon-calendar.svg'

function IconCalendar(props: IconProps): JSX.Element {
  const title = 'icon-calendar'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <Calendar {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconCalendar
